import { Typography } from "@pondigitalsolutions/pon-component-library";
import { BaseImage } from "@components/BaseImage";
import { SbBlokKeyDataTypes } from "@storyblok/react";
import { useGetPrivateAsset } from "@hooks/useGetPrivateAsset";
import { Loader } from "@components/Loader";

interface ImageProps {
  imageData: SbBlokKeyDataTypes;
  isPrivateImage?: boolean;
}

export const Image = ({ imageData, isPrivateImage }: ImageProps) => {
  const image =
    imageData && typeof imageData === "object"
      ? (imageData as { filename?: string; alt?: string; name?: string })
      : null;

  const { data, isLoading, isError } = useGetPrivateAsset({
    assetUrl: image?.filename ?? null,
    isPrivateImage: !!isPrivateImage,
  });

  if (isLoading) {
    return <Loader className="py-4" />;
  }

  if (isError) {
    return null;
  }

  return (
    <div className="my-7 flex flex-col gap-2 lg:my-14">
      <BaseImage
        imageUrl={data?.assetUrl ?? ""}
        alt={image?.alt ?? ""}
        className="mx-auto w-full max-w-2xl object-cover lg:max-w-4xl"
        isPrivate={isPrivateImage}
      />
      {image?.name && (
        <Typography
          size="sm"
          className="leading-[100%] font-normal text-tertiary-900 dark:text-tertiary-100"
        >
          {image.name}
        </Typography>
      )}
    </div>
  );
};
